{
  "w": 11,
  "h": 8,
  "rows": [
    "...........",
    "...WWWWW...",
    "..BCCCCCB..",
    ".BCCCCCCCB.",
    "RBBBWWWBBBR",
    "KWKKKKKKKWK",
    ".KK.....KK.",
    "..........."
  ],
  "legend": {
    "K": "C.BLACK",
    "B": "C.B_BLUE",
    "C": "C.B_CYAN",
    "W": "C.B_WHITE",
    "R": "C.RED"
  }
}
